import TransactionCategoryDetail from "@/controllers/transaction_category/transaction-category-detail.js";

export default {
    extends: TransactionCategoryDetail,
};
